import { Component, OnInit, Input } from '@angular/core';
import { AdOptions, AdSize, AdPosition } from 'capacitor-admob';
import { Plugins } from '@capacitor/core';
import { Storage } from '@ionic/storage-angular';
const { AdMob, Toast } = Plugins;
import { IImmoCalcData } from 'src/app/interfaces/IImmoCalcData';
import { IImmoCalcHistoryData } from 'src/app/interfaces/IImmoCalcHistoryData';
import { ActivatedRoute, Router } from '@angular/router';
import { IImmoCalcHouse } from 'src/app/interfaces/IImmoCalcHouse';
import { AlertController } from '@ionic/angular';

interface IInfoObject {
  title: string,
  info: string
}


@Component({
  selector: 'real-estate-calc',
  templateUrl: './real-estate-calc.component.html',
  styleUrls: ['./real-estate-calc.component.scss'],
})
export class ImmoCalcComponentComponent implements OnInit {
  @Input() name: string;
  historyThreshold: number = 5000; // milliseconds

  lastHistoryUpdateTime = 0;

  immoCalcData: IImmoCalcData = {
    id: Date.now().toString(), // 2Do: GUID
    name: 'Wohnung',
    startBalance: 200000,
    startYear: 0,
    endYear: 30,
    income: 30000,
    savingsRate: 0,
    interest: 6,
    percentRule: 3,
    stopAfter3percentRule: false,
    rentPerMonth: 600,
    immoStartFee: 11,
    immoEquity: 20,
    immoInterest: 2,
    synchInterest: true,
    immoValueGroth: 4
  }

  lines = [];   // auto generated
  history = []; // local copy of history
  houseId: string;
  apartmentId: string;
  houses: Array<IImmoCalcHouse>;
  activeHouse: IImmoCalcHouse;
  activeApartment: IImmoCalcData;

  info = {
    year: {
      title: 'Jahr',
      info: 'In dieser Spalte wird die Anzahl an verstrichenen Jahren angezeigt. '
    },
    sumInvested: {
      title: 'Summe Investiert',
      info: 'In dieser Spalte wird die investierte Summe angegeben. Die investierte Summe bleibt im Verlauf der Jahre gleich, da es diese nur am Anfang der Investition aufgewendet wird.'
    },
    investmentWithInterest: {
      title: 'Investment mit Verzinsung',
      info: 'Das Investment mit Verzinsung bildet den Vergleich zum Immobilien Investment. Wenn der Hacken bei "Synchronisieren" gesetzt ist, wird die Rendite dieses Investments so gewählt, dass es dasselbe Ergebnis liefert wie das Immobilien Investment.'
    },
    realEstateInvestment: {
      title: 'Immobilien Investment',
      info: 'Hier wird die Entwicklung des Immobilien Investments dargestellt. Dabei werden Kreditkosten, Kreditzinsen, Mieteinnahmen und Wertzuwachs berücksichtigt.'
    }
  }

  constructor(private storage: Storage,
    private route: ActivatedRoute,
    private alertController: AlertController) {

    route.params.subscribe(async val => {
      this.updateHouses();

      await this.storage.create();
      this.history = await this.storage.get('history');
      if (!this.history || !this.history.length) {
        this.history = [];
      }
      await this.storage.set('history', this.history);
    });
  }

  async updateHouses() {
    this.houseId = this.route.snapshot.paramMap.get('houseId');
    this.apartmentId = this.route.snapshot.paramMap.get('apartmentId');

    this.activeHouse = undefined;
    this.activeApartment = undefined;

    await this.storage.create();

    this.houses = await this.storage.get('houses');
    if (this.houses && this.houses.length && this.houseId && this.apartmentId) {
      for (let i = 0; i < this.houses.length; i++) {
        if (this.houses[i].id == this.houseId) {
          this.activeHouse = this.houses[i];
          for (let j = 0; j < this.activeHouse.apartments.length; j++) {
            if (this.activeHouse.apartments[j].id == this.apartmentId) {
              this.activeApartment = this.activeHouse.apartments[j];
            }
          }
        }
      }
    }

    if (this.activeHouse && this.activeApartment) {
      this.immoCalcData = this.activeApartment;
    }
    else {
      const immoCalcDataFromStore = await this.storage.get('immoCalcData');
      if (immoCalcDataFromStore) {
        this.immoCalcData = immoCalcDataFromStore;
      }
    }

    this.calculate();
  }

  async ngOnInit() {
    await this.storage.create();
    this.calculate();
  }

  async onChange() {
    await this.storage.set('immoCalcData', this.immoCalcData);

    if (Date.now() - this.lastHistoryUpdateTime <= this.historyThreshold) { // only update once in threshold time
      this.popFromHistory();
    }
    const newHistoryData: IImmoCalcHistoryData = {
      immoCalcData: Object.assign({}, this.immoCalcData),
      timestamp: Date.now()
    }
    await this.pushToHistory(newHistoryData);
    await this.updateHouse(this.immoCalcData);

    this.lastHistoryUpdateTime = Date.now();

    this.calculate();
  }

  async popFromHistory() {
    const last = this.history.shift();
    await this.storage.set('history', this.history);

    return last;
  }

  async pushToHistory(historyObject: IImmoCalcHistoryData) {
    this.history.unshift(historyObject);
    while (this.history.length > 50) {
      this.history.pop();
    }
    await this.storage.set('history', this.history);
  }

  async updateHouse(immoCalcData: IImmoCalcData) {
    for (let i = 0; i < this.houses.length; i++) {
      if (this.houses[i].id == this.houseId) {
        for (let j = 0; j < this.houses[i].apartments.length; j++) {
          if (this.houses[i].apartments[j].id == this.apartmentId) {
            this.houses[i].apartments[j] = Object.assign({}, immoCalcData);
          }
        }
      }
    }
    await this.storage.set('houses', this.houses);
  }

  // This Banner AD have bottom margin to avoid TabBar Overlaping for TabBar 
  showTabBarBanner() {
    console.log('show tabbar banner');
    const options: AdOptions = {
      adId: 'ca-app-pub-7214709202845307/3610149749',
      adSize: AdSize.BANNER,
      isTesting: true,
      position: AdPosition.BOTTOM_CENTER,
      hasTabBar: true,  // make it true if you have TabBar Layout.
      tabBarHeight: 156  // you can assign custom margin in pixel default is 56
    };

    // Show Banner Ad
    AdMob.showBanner(options)
      .then(
        async (value: any) => {
          console.log('show banner 1')
          // console.log(value);  // true
          // await Toast.show({
          //   text: 'Showing Banner AD.'
          // })
        },
        (error: any) => {
          console.log('error showing banner 1')
          console.error(error); // show error
        }
      );
    // Subscibe Banner Event Listener
    AdMob.addListener('onAdLoaded', async (info: boolean) => {
      console.log('Showing TabBar Banner AD.');
    });

    // this.admobService.ShowBanner();
  }
  hideBanner() {
    AdMob.hideBanner().then(
      async (value: any) => {
        // await Toast.show({
        //   text: 'Banner AD Hidden'
        // })
        console.log(value);  // true
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }
  resumeBanner() {
    // Resume the banner, show it after hide
    AdMob.resumeBanner().then(
      (value: any) => {
        console.log(value);  // true
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }
  removeBanner() {
    // Destroy the banner, remove it from screen.
    AdMob.removeBanner().then(
      (value: any) => {
        console.log(value);  // true
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }

  calculate() {
    this.lines = [];
    for (let i = this.immoCalcData.startYear; i <= this.immoCalcData.endYear; i++) {
      const years = i - this.immoCalcData.startYear;
      const messages = [];
      const data = {
        cashflowNegative: false
      };

      const classes = [];

      let rent = this.immoCalcData.rentPerMonth * 12;

      if (this.immoCreditAnnuity() > rent) {
        messages.push(`Cashflow negativ`);
        data.cashflowNegative = true;
        classes.push('cashflowNegative');
      }

      //rent

      let inv0 = this.immoCalcData.startBalance * (this.immoCalcData.immoEquity / 100);
      this.lines.push({ id: i, invested: (Math.round(inv0 * 100) / 100), sum: this.balanceForYear(years), rentSum: this.rentBalanceForYear(years), messages: messages, data, classes });

      if (this.immoCalcData.synchInterest) {
        let wholeTimeSpan = this.immoCalcData.endYear - this.immoCalcData.startYear;
        let factor = this.rentResult() / inv0;
        let p = (Math.pow(factor, 1 / (wholeTimeSpan)) - 1) * 100;
        this.immoCalcData.interest = Math.round(p * 100000000) / 100000000;
      }
    }
  }
  result() {
    let years = this.immoCalcData.endYear - this.immoCalcData.startYear;
    let depositYears = years;

    return this.formatPrice(this.balanceForYearCutDeposit(years, depositYears));
  }
  rentResult() {
    let years = this.immoCalcData.endYear - this.immoCalcData.startYear;
    return this.rentBalanceForYear(years);
  }
  balanceForYearCutDeposit(years: number, depositYears: number) {
    let pInterest = this.immoCalcData.interest / 100 + 1;
    let deposit = (this.immoCalcData.income * this.immoCalcData.savingsRate / 100);
    const inv0 = this.immoCalcData.startBalance * (this.immoCalcData.immoEquity / 100);

    let result = (inv0 * Math.pow(pInterest, years)) + (deposit) * (Math.pow(pInterest, depositYears) - 1) / (pInterest - 1);

    if (years - depositYears > 0) {
      result += ((deposit) * (Math.pow(pInterest, depositYears) - 1) / (pInterest - 1)) * (Math.pow(pInterest, years - depositYears) - 1);
    }

    return Math.round(result * 100) / 100;
  }
  balanceForYear(years: number) {
    return this.balanceForYearCutDeposit(years, years);
  }
  formatPrice(value: number) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '€';
  }
  rentBalanceForYear(years: number) {
    const valueGroth = Math.pow(this.immoCalcData.immoValueGroth / 100 + 1, years);
    let result = this.immoCalcData.startBalance * valueGroth + this.rentForYears(years);

    result -= this.immoCreditAnnuity() * years;
    result -= this.immoCost();

    return result;
  }
  rentForYears(years: number) {
    return (this.immoCalcData.rentPerMonth * 12) * years;
  }
  immoCreditAnnuity() {
    const wholeTimeSpan = this.immoCalcData.endYear - this.immoCalcData.startYear;

    let immoCredit = this.immoCalcData.startBalance * (1 - (this.immoCalcData.immoEquity / 100));
    let anf = (1 / wholeTimeSpan);
    if (this.immoCalcData.immoInterest && this.immoCalcData.immoInterest != 0)
      anf = (this.immoCalcData.immoInterest / 100) / (1 - Math.pow(1 + (this.immoCalcData.immoInterest / 100), - wholeTimeSpan));

    // console.log("number: " + this.immoCalcData.immoInterest);
    // console.log(anf);
    return immoCredit * anf;
  }
  immoCost() {
    return this.immoCalcData.startBalance * (this.immoCalcData.immoStartFee / 100);
  }
  immoIsRentHigherThanCreditAnnuity() {
    return this.immoCreditAnnuity() > this.immoCalcData.rentPerMonth * 12;
  }
  trClasses(data) {
    let output = 'a ';
    for (let d in Array.from(data)) {
      console.log(data[d]);
      if (data[d]) output += d;
    }
    return output.trim();
  }

  async showInfo(e: any, infoObject: IInfoObject) {
    e.stopPropagation();

    const alert = await this.alertController.create({
      header: infoObject.title,
      message: infoObject.info,
      buttons: [
        {
          text: 'Schließen',
          handler: () => {
            return Promise.resolve(true);
          }
        }
      ]
    });

    return await alert.present();
  }
}
